import columns from "./columns";

import formFields from "./formFields";
import previewFields from "./previewFields";
import profileFields from "./profileFields";
import statsFields from "./statsFields";

export default {
    entityName: "suppliers",
    pageTitle: "Suppliers",
    columns,
    searchPlaceholder: "e.g. name:joe",
    formFields,
    previewFields,
    tableOptions: {},
    formOptions: {},
    profileFields,
    statsFields,
    previewOptions: {
        fetchEntity: true,
    },
};
